<template>
    <DsCard>
        <div class="flex items-center gap-3 text-content-primary">
            <DsIcon
                icon="fa-regular fa-user-plus"
                size="md"
            />
            <div class="flex-1">
                <h2 class="text-content-lg font-medium">Add client information</h2>
                <p class="text-content-md text-content-secondary">Add clients to the file and send them tasks to complete</p>
            </div>
            <DsButton
                leading="far fa-plus-circle"
                size="sm"
                variant="secondary"
                @click="$emit('addClient')"
            >
                Add clients
            </DsButton>
        </div>
    </DsCard>
</template>

<script setup lang="ts">
import DsCard from '@/components/design-system/DsCard.vue';
import DsIcon from '@/components/design-system/DsIcon.vue';
import DsButton from '@/components/design-system/form/input/DsButton.vue';

defineEmits<{
    addClient: [];
}>();
</script>
